module.exports = __webpack_public_path__ + "img/ico_tab5_exclusivevipdiscount@3x.fd1a5873.png";